import { render, staticRenderFns } from "./ProfileTabsFour.vue?vue&type=template&id=27430064&scoped=true&"
import script from "./ProfileTabsFour.vue?vue&type=script&lang=js&"
export * from "./ProfileTabsFour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27430064",
  null
  
)

export default component.exports